export type OrderStatus = 'paid' | 'processed' | 'new' | 'overdue' | 'deleted';

export const getOrderStatus = ({
  isPaid,
  isOverdue,
  isDeleted,
  isProcessedWithoutBilling = false,
}: {
  isPaid: boolean;
  isOverdue: boolean;
  isDeleted: boolean;
  isProcessedWithoutBilling?: boolean;
}): OrderStatus => {
  if (isDeleted) {
    return 'deleted';
  }

  if (isPaid) {
    return 'paid';
  }

  if (isProcessedWithoutBilling) {
    return 'processed';
  }

  if (isOverdue) {
    return 'overdue';
  }

  return 'new';
};
